import { t } from "@lingui/macro";
import * as React from "react";
import { Path, G } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const AddNoteIcon = (props: IconProps) => {
  return (
    <Icon fill="none" viewBox="0 0 16 16" title={t`Add Note`} {...props}>
      <G
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        fill="none"
      >
        <Path d="M14 6V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h3M1 4.5h2M6 4.5h5M1 8h2M6 8h2M1 11.5h2M15 12H9M12 9v6" />
      </G>
    </Icon>
  );
};
